import * as React from 'react'
import type { SVGProps } from 'react'
function SvgGeburtenTodesfaelle247035964507Flatline(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 256.5 176.8"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M256,145.8c-1.9-7.3-8.1-12.2-15.2-12l-64.2,2.2c-0.9,0-1.6,0.4-2.2,1c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.9,0.4,1.7,1,2.2 c0.6,0.6,1.4,0.9,2.3,0.8l64.2-2.2c4-0.1,7.6,2.8,8.8,7.2c0.8,3,0.2,6.2-1.5,8.7c-1.5,2.2-3.6,3.5-6.1,3.9l-69.1,9.8 c-4.7,0.6-9.5,0.9-14.2,0.9h-58.7c-4.8,0-9.5-0.9-14-2.5l-4.9-1.8c-8.3-3.1-13-12.5-11-21.9l2.6-12.2c1.8-8.5,8-14.8,15.7-16.2 l76-2.1c1.2,0,2.4,0.5,3.2,1.5c1.3,1.4,1.7,3.5,1,5.5c-0.6,1.7-1.8,2.9-3.3,3.2l-18.9,4.1c-2.5,0.5-5,0.9-7.5,1.2l-27.8,2.8 c-1.8,0.2-3,1.8-2.9,3.5c0.1,0.9,0.5,1.6,1.2,2.2c0.7,0.5,1.5,0.8,2.3,0.7l27.8-2.8c2.8-0.3,5.6-0.7,8.2-1.3l18.9-4.1 c3.8-0.8,6.8-3.6,8.1-7.5c1.3-4.1,0.4-8.6-2.3-11.7c-2.1-2.4-5.1-3.7-8.2-3.6L88,109.5c-0.1,0-0.2,0-0.4,0 c-10.5,1.7-18.8,10.1-21.2,21.2l-2.6,12.2c-2.6,12.5,3.8,25,15.1,29.2l4.9,1.8c5.2,2,10.7,2.9,16.2,2.9h58.8c5,0,10-0.3,15.1-1 L243,166c4.3-0.6,8-2.9,10.5-6.6C256.3,155.7,257.2,150.6,256,145.8z" />
        <path d="M28.1,96.2C12.6,96.2,0,108.8,0,124.3s12.6,28.1,28.1,28.1s28.1-12.6,28.1-28.1S43.5,96.2,28.1,96.2z M28,146 c-11.9,0-21.7-9.7-21.7-21.7S16,102.6,28,102.6s21.7,9.8,21.7,21.7C49.7,136.2,40,146,28,146z" />
        <path d="M69.7,64.5c0.2,0,0.3,0,0.5,0c1.2,0,2.2-0.6,2.8-1.7l11.1-19.7h159.9c1.8,0,3.2-1.5,3.2-3.2s-1.5-3.2-3.2-3.2H82.3 c-1.2,0-2.3,0.6-2.8,1.7l-7.9,13.9L60.9,2.6c-0.3-1.5-1.6-2.5-3.1-2.6c-1.5,0-2.8,0.9-3.2,2.4L44.1,38.9H32l-7.1-13.2 c-0.6-1-1.6-1.7-2.8-1.7c-1.2,0-2.3,0.6-2.9,1.6L9.7,41.2c-0.9,1.5-0.5,3.5,1.1,4.5c1.5,0.9,3.5,0.5,4.5-1.1l6.6-10.8l5.4,9.9 c0.6,1,1.7,1.7,2.9,1.7h16.5c1.4,0,2.7-1,3.1-2.4l7.6-26.5L67,62C67.3,63.3,68.4,64.3,69.7,64.5z" />
      </g>
    </svg>
  )
}
export default SvgGeburtenTodesfaelle247035964507Flatline
